import React, {ComponentProps} from 'react';
import Grid from '@material-ui/core/Grid';
import Text from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import {GridBordered} from './GridBordered';

interface Props extends ComponentProps<typeof Grid> {
  title: string;
}

export const GridNote: React.FC<Props> = ({children, title, ...props}) => {
  const {content, header} = useStyles();
  return (
    <GridBordered {...props}>
      <header className={header}>
        <Text variant="h3">{title}</Text>
      </header>
      <div className={content}>{children}</div>
    </GridBordered>
  );
};

const useStyles = makeStyles(theme => ({
  header: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: theme.mixins.header.height,
    padding: theme.spacing(0, 2),
    position: 'relative',
  },
  content: {
    padding: theme.spacing(2),
  },
}));
